module.exports = __webpack_public_path__ + "img/logo2.bb0f037d.png";